import { getFileApiCall } from "./tokenService";

export const getAttachment = (id: string): Promise<string> => {
    return getFileApiCall("api/attachment?id=" + id);
};